"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var ScrollToTop = function ScrollToTop(_ref) {
  var children = _ref.children;
  var location = (0, _reactRouterDom.useLocation)();

  var _React$useState = _react.default.useState(location.pathname),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      lastPath = _React$useState2[0],
      setLastPath = _React$useState2[1];

  _react.default.useEffect(function () {
    if (typeof window !== 'undefined') {
      if (location.hash && location.hash.trim() !== '') {
        var hash = location.hash.substring(1, location.hash.length);
        var scrollingEl = document.getElementById("".concat(hash));
        scrollingEl ? scrollingEl.scrollIntoView({
          behavior: 'smooth'
        }) : null; // eslint-disable-line
      } else if (location.pathname !== lastPath) {
        window.scrollTo({
          top: 0
          /* , behavior: 'smooth'*/

        });
        setLastPath(location.pathname);
      }
    }
  }, [lastPath, location]);

  return children;
};

var _default = ScrollToTop;
exports.default = _default;